import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

class FlashMessage extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.deleteFlashMessage(this.props.message.id);
  }

  render() {
    console.log(this.props);
    const { type, text } = this.props.message;
    return (
      <div className="row">
        <div className="col-md-offset-2 col-md-8">
          <div
            className={classnames("alert alert-dismissible", {
              "alert-success": type === "success",
              "alert-danger": type === "error"
            })}
          >
            <button onClick={this.onClick} className="close">
              <span>&times;</span>
            </button>
            {text}
          </div>
        </div>
      </div>
    );
  }
}

FlashMessage.propTypes = {
  message: PropTypes.object.isRequired,
  deleteFlashMessage: PropTypes.func.isRequired
};

export default FlashMessage;



// WEBPACK FOOTER //
// ./src/flash/FlashMessage.js